<template>
    <div class="relative">
      <div v-if="formData.details.length" class="sticky top-0 left-0 z-40  w-full flex items-center justify-between mt-0 px-6 py-4" :class="Math.sign(formData.amount)==-1?'bg-red-200':'bg-teal-200'">
          <div class="hidden md:flex md:items-center md:w-auto w-full order-3 md:order-1">
              <div class="flex flex-wrap items-center justify-between text-base text-blue-600 pt-4 md:pt-0">
                   <svg :class="Math.sign(formData.amount)==-1?'text-red-600':'text-teal-600'" class="h-8 w-8 mr-4 inline" viewBox="0 0 20 20" fill="currentColor">  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
                   <div class="flex flex-wrap">
                      <span :class="Math.sign(formData.amount)==-1?'text-red-800':'text-teal-800'" class="text-lg inline w-full">{{formData.details.length + ' Orders are selected'}}</span>
                      <span v-if="formData.expeditions.length>0" :class="Math.sign(formData.amount)==-1?'text-red-800':'text-teal-800'" class="text-lg inline  w-full">{{formData.expeditions.length + ' Expeditions are selected'}}</span>
                      <span v-if="formData.sourcings.length>0" :class="Math.sign(formData.amount)==-1?'text-red-800':'text-teal-800'" class="text-lg inline  w-full">{{formData.sourcings.length + ' Sourcings are selected'}}</span>
                      <span v-if="formData.refunds.length>0" :class="Math.sign(formData.amount)==-1?'text-red-800':'text-teal-800'" class="text-lg inline  w-full">{{formData.refunds.length + ' Refunds are selected'}}</span>
                      <span v-if="formData.subscription_fees!=0" :class="Math.sign(formData.amount)==-1?'text-red-800':'text-teal-800'" class="text-lg inline  w-full">Subscription fees</span>
                      <span v-if="formData.avoir_fees.length>0"  :class="Math.sign(formData.amount)==-1?'text-red-800':'text-teal-800'" class="text-lg inline  w-full">Avoir amount (+)</span>
                   </div>
                  
              </div>
          </div>
          <div class="order-2 md:order-3 flex flex-wrap items-center justify-end mr-0 md:mr-4">
              <div class="auth flex items-center w-full md:w-full">
                   <div :class="Math.sign(formData.amount)==-1?'text-red-800':'text-teal-800'" class="font-bold text-lg inline">Total amount: <span>{{formData.amount.toFixed(2)}} <sup>{{idWharhouse.currency}}</sup></span></div>
              </div>
           </div>  
      </div>
      <div class="flex-1 mt-1 bg-gray-100 px-4 pt-12 items-center">
          <div class="bg-white w-fullrounded-lg shadow form-payement"> 
              <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-2">
                  <div class="flex w-1/3">
                       <button
                          :class="$colors.primary"
                          class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
                          @click="RouterBack()"
                      >
                          <i class="material-icons">chevron_left</i>
                      </button>
                      <div v-if="!formData._id" class="text-2xl font-bold text-blue-500">New Payment</div>
                  </div>
                  <div class="w-full flex justify-end space-x-4">
                     <button v-if="formData.seller" @click="OpenClosePopPayMethode('open','selectOrders')"  class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-blue-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300">Generate</button>
                      <button @click="reset"  class="rounded relative loidingconfirm focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-orange-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300" :disabled="loadingReset"><loading :active.sync="loadingReset" :is-full-page="fullPage"></loading>Reset</button>
                  </div>    
              </div>
              <div class="">
                  <div class="bg-white rounded-lg p-6 pt-2 mb-20">
                      <div class="-mx-3 items-center md:flex mb-6 border pt-1 pb-2 p-5 border-dotted rounded-md border-gray-500">
                          <div class="md:w-2/5 px-3 mb-6 md:mb-0">
                             <span class="block mb-3">Select a Seller:</span>
                              <div class="border-2 h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                      <p>
                                      <label for="seller" class="bg-white text-gray-700 px-1"> Seller <span :class="$colors.required">*</span></label>
                                      </p>
                                  </div>
                                  <p>
                                      <v-select @input="getOrdersBySeller"  @search="getUsersDebance($event,'shipsen')"  label="fullName" v-model="formData.seller" :options="sellers" ></v-select>
                                  </p>
                              </div>
                          </div>
                          <div class="w-px h-15 border border-r border-dashed border-gray-300 dark:border-dark-5 mx-4 xl:mx-5"></div>
                          <div class="md:w-3/5 px-3">
                              <div  class="inline-block w-full">
                                  <span class="block mb-3">Date de facturation:</span>
                                  <div class="inline-block w-1/3 pr-1">
                                      <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"><p><label for="date" class="bg-white text-gray-700 px-1">From</label></p></div>
                                          <p>  <input  v-model="datePaidAt.fromDate" class="w-full px-1 py-1 text-gray-700 bg-gray-200 rounded" id="from" type="date"> </p>
                                      </div>
                                  </div>
                                      <div class="inline-block w-1/3 pr-1">
                                      <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"><p><label for="date" class="bg-white text-gray-700 px-1">To <span class="text-blue-500">*</span></label></p></div>
                                          <p>  <input  v-model="datePaidAt.toDate" class="w-full px-1 py-1 text-gray-700 bg-gray-200 rounded" id="to" type="date"> </p>
                                      </div>
                                  </div>
                                  <div class="inline-block text-right w-1/3 pr-1">
                                      <button @click="FindOrderByBetweenDate" :disabled="datePaidAt.toDate==null || loadingFind" :class="!formData.seller?'w-full':''" class="mr-2 relative loidingconfirm  px-4 py-2 text-white font-light tracking-wider bg-blue-700 rounded"><loading :active.sync="loadingFind" :is-full-page="fullPage"></loading> Find</button>
                                      <button v-if="formData.seller" @click="refreshDataSeller" class="px-2 py-2 text-blue-500 hover:text-white font-light tracking-wider bg-gray-300 hover:bg-yellow-600 relative loidingconfirm  rounded" :disabled="loadingRefresh"><loading :active.sync="loadingRefresh" :is-full-page="fullPage"></loading> Refresh <i class="material-icons align-bottom">refresh</i></button>
                                  </div>
                              </div>
                               <div class="relative mx-auto text-gray-600 mt-2" v-if="formData.seller && !datePaidAt.toDate">
                                  <input class="border-2 w-full  border-gray-300 bg-white h-10 px-5 pr-16 rounded-lg text-sm focus:outline-none" placeholder="Search order by id ..." v-model="searchText"  type="search">
                                  <button @click="search" type="submit" class="absolute right-0 top-0 mt-3 mr-4 bg-white rounded-r-md hover:opacity-75  focus:outline-none">
                                  <svg class="text-gray-600 h-4 w-4 fill-current" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 56.966 56.966" style="enable-background:new 0 0 56.966 56.966;" xml:space="preserve" width="512px" height="512px">
                                      <path d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z"></path>
                                  </svg>
                                  </button>
                              </div>
                          </div>
                      </div>
                         
                      <!-- Order selectioner -->
                      <div v-if="orders.length >0"  class="mt-5 overflow-x-auto bg-white rounded-lg  overflow-y-auto relative">
                          <div class="w-full  bg-white mt-1 mb-5 shadow-lg border overflow-hidden">
                              <div class="py-2 text-center font-bold uppercase tracking-wide text-white bg-blue-500"><i class="material-icons align-bottom">perm_identity</i> Seller: {{formData.seller.fullName}}</div>
                                  <div class="flex items-center justify-between py-2 px-3 bg-gray-400">
                                  <h1 class="text-gray-800 font-bold "><sup>{{idWharhouse.currency}}</sup> {{totalOrdersAmountFees().amount.toFixed(2) }} <span>(Total orders: {{totalOrdersAmountFees().count}})</span></h1>
                                  <button v-if="formData.details.length==0 && formData.expeditions.length==0 && formData.sourcings.length==0 && formData.refunds.length==0"  @click="OpenClosePopPayMethode('open','allOrders')" class="bg-gray-800 text-xs text-white px-5 py-1 font-semibold rounded uppercase hover:bg-gray-700">Generate all</button>
                              </div>
                          </div>
                         
                          <table class="border-collapse border table-auto w-full whitespace-no-wrap bg-white table-striped relative">
                              <thead>
                                  <tr class="text-left">
                                      <th class="py-1 w-5 px-3 sticky top-0 border-b border-gray-200  text-white bg-blue-500  border-gray-300">
                                          <label
                                              class="text-teal-500 inline-flex justify-between items-center hover:bg-gray-200 px-2 py-2 rounded-lg cursor-pointer">
                                              <input type="checkbox" class="form-checkbox checkallbbox focus:outline-none focus:shadow-outline" @click="selectAllCheckbox($event);">
                                          </label>
                                      </th>
                                      <th v-for="(heading,ind) in headings" :key="ind" class="text-center text-xss font-bold uppercase text-white bg-blue-500 border border-gray-300">{{heading.value}}</th>
                                  </tr>
                              </thead>
                              <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                              <tableBody v-for="(order,ind) in orders" :key="ind" :item="order" :warehouse="idWharhouse" :serviceFeesRate="serviceFeesRate"  :confvat="confirmation_vat" :ship_vat="shipping_vat" :ship_refund_vat="shipping_refund_vat" :ship_change_vat="shipping_change_vat" :formData="formData" :shippings="shippings" :shippingSettings="settings.shipping" @getRowDetail="getRowDetail" @UpdateRowFees="UpdateRowFees"  />   
                          </table>
                          <!-- Orders Fess -->
                          <table  class="min-w-full relative">
                              <thead>
                                  <tr>
                                      <th :colspan="8" class="text-center text-white bg-blue-500 px-6 py-3 border-b-2 border-t-2 border-gray-300 text-left leading-4 tracking-wider">Orders Fees (total orders traits: {{ordersFees.reduce((a,curr) => a + curr.count, 0)}})</th>   
                                  </tr>
                              </thead>
                              <loading :active.sync="loadingordersFees" :is-full-page="fullPage"></loading>
                              <tbody class="bg-white">
                                  <tr>
                                      <td :colspan="8" class="px-10 py-2 whitespace-no-wrap border-b-2 border-r-2 border-l-2 text-center">
                                            <div class="flex items-center justify-center">
                                                <div>
                                                    <div class="text-primary dark:text-slate-300 text-lg xl:text-xl font-medium"> {{ordersFees[0].name}} </div>
                                                    <div class="mt-0.5 text-slate-500">{{ordersFees[0].count}} </div>
                                                </div>
                                                <div class="w-px h-12 border border-r border-dashed border-gray-600 dark:border-darkmode-300 mx-4 xl:mx-5"></div>
                                                <div>
                                                    <div class="text-slate-500 text-lg xl:text-xl font-medium"> {{ordersFees[1].name}} </div>
                                                    <div class="mt-0.5 text-slate-500">{{ordersFees[1].count}}</div>
                                                </div>
                                                <div class="w-px h-12 border border-r border-dashed border-gray-600 dark:border-darkmode-300 mx-4 xl:mx-5"></div>
                                                <div>
                                                    <div class="text-slate-500 text-lg xl:text-xl font-medium"> {{ordersFees[2].name}} </div>
                                                    <div class="mt-0.5 text-slate-500">{{ordersFees[2].count}}</div>
                                                </div>
                                                <div class="w-px h-12 border border-r border-dashed border-gray-600 dark:border-darkmode-300 mx-4 xl:mx-5"></div>
                                                <div>
                                                    <div class="text-slate-500 text-lg xl:text-xl font-medium"> {{ordersFees[3].name}} </div>
                                                    <div class="mt-0.5 text-slate-500">{{ordersFees[3].count}}</div>
                                                </div>
                                                <div class="w-px h-12 border border-r border-dashed border-gray-600 dark:border-darkmode-300 mx-4 xl:mx-5"></div>
                                                <div>
                                                    <div class="text-slate-500 text-lg xl:text-xl font-medium"> {{ordersFees[4].name}} </div>
                                                    <div class="mt-0.5 text-slate-500">{{ordersFees[4].count}}</div>
                                                </div>
                                            </div>
                                            <vue-slider v-model="formData.order_fees.limit" v-bind="slider.options" :tooltip="'always'" :tooltip-formatter="slider.formatter1"/>
                                      </td>
                                  </tr>
                              </tbody>       
                          </table>   
                          <!-- Expedition -->
                          <table v-if="expeditions.length >0" class="min-w-full relative">
                              <thead>
                                  <tr>
                                      <th :colspan="8" class="text-center text-white bg-blue-500 px-6 py-3 border-b-2 border-t-2 border-gray-300 text-left leading-4 tracking-wider">Expeditions</th>   
                                  </tr>
                              </thead>
                                  <thead>
                                  <tr>
                                      <th class="text-center w-5 bg-gray-100 px-6 py-2 text-sm border-b-2 border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider"></th> 
                                      <th class="text-center w-5 bg-gray-100 px-6 py-2 text-sm border-b-2 border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">ID</th> 
                                      <th class="text-center w-5 bg-gray-100 px-6 py-2 text-sm border-b-2 border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider"> WEIGHT (KG)</th> 
                                      <th class="text-center w-5 bg-gray-100 px-6 py-2 text-sm border-b-2 border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">Reception date</th>  
                                      <th class="text-center w-5 bg-gray-100 px-6 py-2 text-sm border-b-2 border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">DETAILS</th>   
                                      <th class="text-center w-5 bg-gray-100 px-6 py-2 text-sm border-b-2 border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">CARRIER</th>   
                                      <th class="text-center w-5 bg-gray-100 px-6 py-2 text-sm border-b-2 border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">COUNTRY</th> 
                                      <th class="text-center w-5 bg-gray-100 px-6 py-2 text-sm border-b-2 border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">EXPEDITION FEES</th>     
                                  </tr>
                              </thead>
                              <loading :active.sync="loadingExpeditions" :is-full-page="fullPage"></loading>
                              <tbody class="bg-white">
                                  <tr v-for="(exp,ind) in expeditions" :key="ind">
                                      <td class="px-6 py-2 whitespace-no-wrap border-b-2 border-r-2 border-l-2 text-center">
                                          <input type="checkbox" :id="exp._id" @click="getRowDetailExp($event,exp,exp._id)"  class="form-checkbox checkbox-exp focus:outline-none focus:shadow-outline"> 
                                      </td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2 text-center"><div class="text-sm leading-5 text-blue-900 capitalize ">{{exp.id}}</div></td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2 text-center"><div class="text-sm leading-5 text-blue-900 capitalize ">{{exp.weight}}</div></td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2 text-center"><div class="text-sm leading-5 text-blue-900 capitalize ">{{$moment(exp.arrivalDate).format('yyyy-MM-DD')}}</div></td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2 text-center"><div class="text-sm leading-5 text-blue-900 capitalize ">{{exp.details.length}} Products</div></td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2 text-center"><div class="text-sm leading-5 text-blue-900 capitalize ">{{exp.carrier.name}}</div></td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2 text-center"><div class="text-sm leading-5 text-blue-900 capitalize ">{{exp.country}}</div></td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2  border-r-2 text-center"><div class="text-sm leading-5 font-bold text-blue-900 capitalize ">{{exp.fees }} <sup>{{idWharhouse.currency}}</sup></div></td>
                                  </tr>
                              </tbody>       
                          </table>   
                          <!-- REfunds -->
                          <table v-if="refunds.length >0" class="min-w-full relative">
                              <thead>
                                  <tr>
                                      <th :colspan="7" class="text-center text-white bg-blue-500 px-6 py-3 border-b-2 border-t-2 border-gray-300 text-left leading-4 tracking-wider">Refunds</th>   
                                  </tr>
                              </thead>
                                  <thead>
                                  <tr>
                                      <th class="text-center w-5 bg-gray-100 px-6 py-2 text-sm border-b-2 border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider"></th> 
                                      <th class="text-center bg-gray-100 px-6 py-2 text-sm  border-b-2 border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">ID</th> 
                                      <th class="text-center bg-gray-100 px-6 py-2 border-b-2 text-sm  border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">DATE ACCEPTED</th>  
                                      <th class="text-center bg-gray-100 px-6 py-2 border-b-2 text-sm border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">SELLER</th> 
                                      <th class="text-center bg-gray-100 px-6 py-2 border-b-2 text-sm  border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">PRODUCTS</th>   
                                      <th class="text-center bg-gray-100 px-6 py-2 border-b-2 text-sm  border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">CUSTUMER</th>   
                                      <th class="text-center bg-gray-100 px-6 py-2 border-b-2 text-sm  border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">REFUND</th>    
                                  </tr>
                              </thead>
                              <loading :active.sync="loadingRefunds" :is-full-page="fullPage"></loading>
                              <tbody class="bg-white">
                                  <tr v-for="(exp,ind) in refunds" :key="ind">
                                      <td class="px-6 py-2 whitespace-no-wrap border-b-2 border-r-2 border-l-2 text-center">
                                          <input type="checkbox" :id="exp._id" @click="getRowDetailRefund($event,exp,exp._id)"  class="form-checkbox checkbox-ref focus:outline-none focus:shadow-outline"> 
                                      </td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2 text-center"><div class="text-sm leading-5 text-blue-900">{{exp.id}}</div></td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2 text-center"><div class="text-sm leading-5 text-blue-900 capitalize ">{{$moment(exp.acceptedAt).format('yyyy-MM-DD HH:mm') }}</div></td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2 text-center"><div class="text-sm leading-5 text-blue-900 capitalize ">{{exp.ObjetDetails.fullName}}</div></td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2 text-center"><div class="text-sm leading-5 text-blue-900 capitalize ">{{ProductNamesGroup(exp.ObjetDetails.products)}}</div></td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2 text-center"><div class="text-sm leading-5 text-blue-900 capitalize " v-if="exp.ObjetDetails.customer">{{exp.ObjetDetails.customer.fullName}}</div><div v-if="exp.ObjetDetails.customer" class="font-light text-gray-700 text-smm">{{exp.ObjetDetails.customer.phone}}</div></td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2 border-r-2 text-center"><div class="text-sm leading-5 font-bold text-blue-900 capitalize ">{{exp.ObjetDetails.totalPrice }} <sup>{{idWharhouse.currency}}</sup></div></td>
                                  </tr>
                              </tbody>       
                          </table> 
                           <!-- Sourcing -->
                          <table v-if="sourcings.length >0" class="min-w-full relative">
                              <thead>
                                  <tr>
                                      <th :colspan="8" class="text-center text-white bg-blue-500 px-6 py-3 border-b-2 border-t-2 border-gray-300 text-left leading-4  tracking-wider">Sourcings</th>   
                                  </tr>
                              </thead>
                                  <thead>
                                  <tr>
                                      <th class="text-center w-5  bg-gray-100 px-6 py-2 border-b-2 text-sm border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider"></th> 
                                      <th class="text-center bg-gray-100 px-6 py-2 border-b-2 text-sm border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">ID</th> 
                                      <th class="text-center bg-gray-100 px-6 py-2 border-b-2 text-sm border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">VALIDATION DATE</th>  
                                      <th class="text-center bg-gray-100 px-6 py-2 border-b-2 text-sm border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">SELLER</th> 
                                      <th class="text-center bg-gray-100 px-6 py-2 border-b-2 text-sm border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">DETAILS</th>   
                                      <th class="text-center bg-gray-100 px-6 py-2 border-b-2 text-sm border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">PROVIDER</th>   
                                      <th class="text-center bg-gray-100 px-6 py-2 border-b-2 text-sm border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">COUNTRY</th> 
                                          <th class="text-center bg-gray-100 px-6 py-2 border-b-2  text-sm border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">AMOUNT</th>     
                                  </tr>
                              </thead>
                              <loading :active.sync="loadingSourcings" :is-full-page="fullPage"></loading>
                              <tbody class="bg-white">
                                  <tr v-for="(exp,ind) in sourcings" :key="ind">
                                      <td class="px-6 py-2 whitespace-no-wrap border-b-2 border-r-2 border-l-2 text-center">
                                          <input type="checkbox" :id="exp._id" @click="getRowDetailSourcing($event,exp,exp._id)"  class="form-checkbox checkbox-sour focus:outline-none focus:shadow-outline"> 
                                      </td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2 text-center"><div class="text-sm leading-5 text-blue-900 ">{{exp.id}}</div></td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2 text-center"><div class="text-sm leading-5 text-blue-900 capitalize ">{{$moment(exp.validationDate).format('yyyy-MM-DD HH:mm')}}</div></td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2 text-center"><div class="text-sm leading-5 text-blue-900 capitalize ">{{exp.sellerObject.fullName}}</div></td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2 text-center"><div class="text-sm leading-5 text-blue-900 capitalize ">{{exp.details.length}} Products</div></td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2 text-center"><div class="text-sm leading-5 text-blue-900 capitalize ">{{exp.provider.name}}</div><div class="font-light text-gray-700 text-smm">{{exp.provider.phone}}</div></td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2 text-center"><div class="text-sm leading-5 text-blue-900 capitalize ">{{exp.country}}</div></td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2  border-r-2 text-center"><div class="text-sm leading-5 font-bold text-blue-900 capitalize ">{{QuantityTotalOrPrices('price',exp.details)+QuantityTotalOrPrices('price',exp.fees) }} <sup>{{idWharhouse.currency}}</sup></div></td>
                                  </tr>
                              </tbody>       
                          </table>  
                           <!-- Avoirs -->
                          <table v-if="avoir_fees.length >0"  class="min-w-full relative">
                              <thead>
                                  <tr>
                                      <th :colspan="2" class="text-center text-white bg-green-500 px-6 py-3 border-b-2 border-t-2 border-gray-300 text-left leading-4  tracking-wider">Avoir fees <i class="material-icons mx-2 align-bottom">card_giftcard</i></th>   
                                  </tr>
                              </thead>
                              <thead>
                                  <tr>
                                      <th class="text-center w-5 bg-gray-100 px-6 py-2 border-b-2 text-sm border-t-2 border-gray-300 text-left leading-4 text-green-500 tracking-wider"></th> 
                                      <th  class="text-center bg-gray-100 px-6 py-2 border-b-2  text-sm border-t-2 border-gray-300 text-left leading-4 text-green-500 tracking-wider">AMOUNT</th>     
                                  </tr>
                              </thead>
                              <loading :active.sync="loadingAvoir_fees" :is-full-page="fullPage"></loading>
                              <tbody class="bg-white">
                                  <tr v-for="(av,inddd) in avoir_fees" :key="inddd">
                                      <td class="px-6 py-2 whitespace-no-wrap border-b-2 border-r-2 border-l-2 text-center">
                                          <input type="checkbox" :id="av._id" @click="getRowDetailAvoir($event,av,av._id)"  class="form-checkbox checkbox-subs focus:outline-none focus:shadow-outline"> 
                                      </td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2  border-r-2 text-center"><div class="text-sm leading-5 font-bold text-blue-900 capitalize ">{{av.amount}} <sup>{{idWharhouse.currency}}</sup></div></td>
                                  </tr>
                              </tbody>       
                          </table>    
                          <!-- Soubscription -->
                          <table  class="min-w-full" style="margin-bottom: 60px;">
                              <thead>
                                  <tr>
                                      <th :colspan="2" class="text-center text-white bg-blue-500 px-6 py-3 border-b-2 border-t-2 border-gray-300 text-left leading-4  tracking-wider">Subscription fees</th>   
                                  </tr>
                              </thead>
                                  <thead>
                                  <tr>
                                      <th class="text-center w-5 bg-gray-100 px-6 py-2 border-b-2 text-sm border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider"></th> 
                                      <th class="text-center bg-gray-100 px-6 py-2 border-b-2  text-sm border-t-2 border-gray-300 text-left leading-4 text-blue-500 tracking-wider">FEES</th>     
                                  </tr>
                              </thead>
                              <tbody class="bg-white">
                                  <tr>
                                      <td class="px-6 py-2 whitespace-no-wrap border-b-2 border-r-2 border-l-2 text-center">
                                          <input type="checkbox" @click="getRowDetailSubscription($event)"  class="form-checkbox checkbox-subs focus:outline-none focus:shadow-outline"> 
                                      </td>
                                      <td class="px-4  border-b-2 whitespace-no-wrap border-b-2  border-t-2  border-r-2 text-center"><div class="text-sm leading-5 font-bold text-blue-900 capitalize ">{{settings.subscription_fees}} <sup>{{idWharhouse.currency}}</sup></div></td>
                                  </tr>
                              </tbody>       
                          </table>   
                      </div>
                      <!--end  Order selectioner -->
                          <!--order by seller-->
                          <div  class="mt-6" style="overflow-x: auto;" v-if="!isFilter && !formData.seller">
                               <div class="flex justify-center border-gray-200">
                                  <div class="w-5/12 relative bg-blue-100 border-t-4 border-blue-600 rounded-b text-teal-darkest px-4 py-3 shadow-md my-2" role="alert">
                                   <loading :active.sync="loadingorderbyseller" :is-full-page="fullPage"></loading>
                                      <div class="flex">
                                          <i class="large material-icons mr-5">account_balance_wallet</i>   
                                          <div>
                                          <p class="font-bold">Total orders: <span>{{ordersByseller.reduce((a,curr) => a + curr.count, 0)}}</span></p>
                                          <p class="font-bold">Amount total: <sup v-if="idWharhouse">{{idWharhouse.currency}}</sup> {{ordersByseller.reduce((a,curr) => a + curr.amount, 0).toFixed(2)}} </p>
                                          </div>  
                                      </div>
                                  </div>
                              </div>
                               <button @click="downloadCsv"  class="btnn cursor-pointer float-right mb-2 bg-blue-500 text-gray-100  hover:bg-blue-700 box flex items-center dark:text-gray-300"><svg  xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-file-text hidden sm:block w-4 h-4 mr-2 hidden sm:block w-4 h-4 mr-2"><path  d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline  points="14 2 14 8 20 8"></polyline><line  x1="16" y1="13" x2="8" y2="13"></line><line  x1="16" y1="17" x2="8" y2="17"></line><polyline  points="10 9 9 9 8 9"></polyline></svg> Export to Excel </button>
                              <table class="min-w-full w-full relative">
                                  <thead class="relative">
                                      <tr class="bg-gray-400 text-gray-600 uppercase text-sm leading-normal">
                                          <th class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider text-left"><span> Seller </span></th>
                                          <th class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider text-center"><span> Number of orders </span></th>
                                          <th class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider text-center"><span> Amount to pay </span></th>
                                          <th class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider text-center"><span> Action </span></th>
                                      </tr>
                                  </thead>
                                  <loading :active.sync="loadingorderbyseller" :is-full-page="fullPage"></loading>
                                  <tableTotalAmount v-for="(totalorders,index) in ordersByseller" :key="index" :warehouse="idWharhouse" :sellerSelect="sellerSelect" :loadingShowPay="loadingShowPay" :item="totalorders"  @getOrdersBySeller="getOrdersBySeller" @OpenClosePopPayMethode="OpenClosePopPayMethode"/>   
                              </table>
                              <dialog class="printingExcel">
                                  <modal-export-excel-payments type="ordersByseller" :items="ordersByseller" />
                              </dialog>   
                          </div>
                          <!--/order by seller-->
                          <div v-if="formData.seller && orders.length==0" class="relative bg-blue-100 py-8 mt-1">
                            <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                              <span class="w-full flex justify-center text-center py-3 border-b border-gray-200 text-base">
                                  <p class="font-semibold flex text-blue-500 whitespace-no-wrap">
                                      <i class="material-icons mx-3">error</i>
                                      <span class>No order to paid for this Seller</span>
                                  </p>
                              </span>
                          </div>
                          <!--pagination -->
                          <div class="p-1" v-if="paginate.lastpage > 1" >
                              <div class="flex flex-col items-center my-12">
                                  <div-paginate  :paginate="paginate" @paginatation="paginatation" />
                              </div>
                          </div>
                          <!--end pagination -->
                  </div>
                  <div  v-if="formData.details.length"  class="w-full pay">
                      <div class="pt-3 btn-bottom-toolbar flex items-center">
                          <button v-if="formData.seller" @click="OpenClosePopPayMethode('open','selectOrders')"  class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-blue-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300">Generate</button>
                          <table class="w-full ml-auto">
                              <tbody>
                                  <tr class="">
                                      <td class="w-2/3" colspan="3"></td>
                                      <td class="text-sm font-bold pl-4 border-b-2"><b>Total Sales</b></td>
                                      <td class="text-sm font-bold tracking-wider border-b-2"><b><sup>{{idWharhouse.currency}}</sup> {{getCost().total.toFixed(2)}}</b></td>
                                  </tr>
                                  <!-- <tr>
                                      <th class="w-2/3" colspan="3"></th>
                                      <td class="text-sm font-bold pl-4 border-b-2"><b>Service fees ({{serviceFeesRate}}%)</b></td>
                                      <td class="text-sm font-bold border-b-2"><b><sup>{{idWharhouse.currency}}</sup> {{getCost().serviceFees.toFixed(2)}}</b></td>
                                  </tr> -->
                                  <tr>
                                      <th class="w-2/3" colspan="3"></th>
                                      <td class="text-sm border-b-2 font-bold pl-4"><b>Total Fees</b></td>
                                      <td  class="text-sm border-b-2 font-bold"><b><sup>{{idWharhouse.currency}}</sup> {{getCost().fees.toFixed(2)}}</b></td>
                                  </tr>
                                  <!-- NEW: Breakdown of fees (optional) -->
                                <tr>
                                    <th class="w-2/3" colspan="3"></th>
                                    <td class="text-sm border-b-2 pl-4 text-gray-600">- Confirmation Fees</td>
                                    <td class="text-sm border-b-2 text-gray-600">
                                        <sup>{{idWharhouse.currency}}</sup> {{getCost().confirmationFees.toFixed(2)}}
                                    </td>
                                </tr>
                                <tr>
                                    <th class="w-2/3" colspan="3"></th>
                                    <td class="text-sm border-b-2 pl-4 text-gray-600">- Shipping Fees</td>
                                    <td class="text-sm border-b-2 text-gray-600">
                                        <sup>{{idWharhouse.currency}}</sup> {{getCost().shippingFees.toFixed(2)}}
                                    </td>
                                </tr>

                                <tr>
                                    <th class="w-2/3" colspan="3"></th>
                                    <td class="text-sm border-b-2 pl-4 text-gray-600">- Services Fees ({{serviceFeesRate}}%)</td>
                                    <td class="text-sm border-b-2 text-gray-600">
                                        <sup>{{idWharhouse.currency}}</sup> {{getCost().serviceFees.toFixed(2)}}
                                    </td>
                                </tr>

                                  <tr v-if="getCost().order_fees">
                                      <th class="w-2/3" colspan="3"></th>
                                      <td class="text-sm border-b-2 font-bold pl-4"><b>Orders Fees</b></td>
                                      <td class="text-sm border-b-2 font-bold"><b><sup>{{idWharhouse.currency}}</sup> {{getCost().order_fees}}</b> ({{formData.order_fees.limit}} Orders)</td>
                                  </tr>
                                  <tr v-if="getCost().expedition">
                                      <th class="w-2/3" colspan="3"></th>
                                      <td class="text-sm border-b-2 font-bold pl-4"><b>Expeditions Fees</b></td>
                                      <td class="text-sm border-b-2 font-bold"><b><sup>{{idWharhouse.currency}}</sup> {{getCost().expedition}}</b></td>
                                  </tr>
                                  <tr v-if="getCost().sourcing">
                                      <th class="w-2/3" colspan="3"></th>
                                      <td class="text-sm border-b-2 font-bold pl-4"><b>Sourcings Fees</b></td>
                                      <td class="text-sm border-b-2 font-bold"><b><sup>{{idWharhouse.currency}}</sup> {{getCost().sourcing}}</b></td>
                                  </tr>
                                  <tr v-if="getCost().refund">
                                      <th class="w-2/3" colspan="3"></th>
                                      <td class="text-sm border-b-2 font-bold pl-4"><b>Refunds Fees</b></td>
                                      <td class="text-sm border-b-2 font-bold"><b><sup>{{idWharhouse.currency}}</sup> {{getCost().refund}}</b></td>
                                  </tr>
                                  <tr v-if="getCost().subscription">
                                      <th class="w-2/3" colspan="3"></th>
                                      <td class="text-sm font-bold pl-4"><b>Subscription Fees</b></td>
                                      <td class="text-sm font-bold"><b><sup>{{idWharhouse.currency}}</sup> {{getCost().subscription}}</b></td>
                                  </tr>
                                   <tr v-if="getCost().avoir">
                                      <th class="w-2/3" colspan="3"></th>
                                      <td class="text-sm font-bold pl-4"><b>Avoir Amount</b></td>
                                      <td class="text-sm font-bold"><b><sup>{{idWharhouse.currency}}</sup> {{getCost().avoir}} (+)</b></td>
                                  </tr>
                                  <tr class="">
                                      <th class="w-2/3" colspan="3"></th>
                                      <td class="text-sm font-bold text-white bg-gray-800 pl-4"><b>Total</b></td>
                                      <td class="text-sm font-bold text-white bg-gray-800"><b><sup>{{idWharhouse.currency}}</sup> {{getCost().subTotal.toFixed(2)}}</b></td>
                                  </tr>
                              </tbody>
                          </table>
                       </div>
                  </div>
              </div>
          </div>
      </div>
       <vue-modal-2 name="ModalPay" :headerOptions="{title: 'Payement methode'}"  :noFooter="true" modalSize="lg" @on-close="OpenClosePopPayMethode('close','ModalPay')">
          <loading :active.sync="loadingPay" :is-full-page="fullPage"></loading>
          <div class="bg-white rounded-lg">
              <div class="w-96 rounded-lg flex">
              <div class="w-1/3 pt-6 flex justify-center items-center">
                  <span class="w-16 h-16 bg-blue-600  text-white p-3 rounded-full"><i class="material-icons" style="font-size: 40px;">payment</i></span>
              </div>
              <div class="w-full pr-4">
                  <h3 class="font-bold text-blue-600 mb-10">Payement methode</h3>
                 <div class="flex flex-wrap">  
                     <!-- <div class="w-full lg:w-1/2 px-4">
                          <div class="mb-5 border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                  <p>
                                      <label for="tva" class="bg-white text-gray-700 px-1">TVA (%)</label>
                                  </p>
                              </div> 
                              <p>
                                  <v-select @input="setTva" v-model="tvaPayement" :options="tva" ></v-select> 
                              </p>
                          </div>
                      </div>
                      <div class="w-full lg:w-1/2 px-4">
                              <div class="mb-5 border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                      <p>
                                          <label for="transfert_fees" class="bg-white text-gray-700 px-1">Transfert fees</label>
                                      </p>
                                  </div> 
                                  <p>  
                                        <input id="transfert_fees" @input="setTranferfees" v-model="transfertFees"  type="number" min="0"  class="py-2 text-xs px-2 outline-none block h-full w-full"/> 
                                  </p>
                              </div>
                      </div>-->
                  </div>  
                   <div class="w-full px-4">    
                      <div class="mb-5 border hover:border-blue-500  focus-within:border-blue-500 focus-within:text-blue-500  transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                              <p>
                                  <label for="country" class="bg-white text-gray-700 px-1">Payement methode</label>
                              </p>
                          </div> 
                          <p>
                              <v-select @input="setSelected" v-model="formData.method" :options="options" label="name">
                                  <template slot="option" slot-scope="option">
                                      <img class="flag-img" :src="getImagePay(option.name)"/>
                                          {{ option.name }} 
                                  </template>
                              </v-select>
                          </p>
                      </div>
                  </div>
              </div>
              </div>
  
              <div class="p-4 flex space-x-4">
              <a href="#" @click="OpenClosePopPayMethode('close','ModalPay')" class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm">Cancel</a>
              <a href="#"  @click="confirmData" class="w-1/2 px-4 py-3 text-center text-blue-100 bg-blue-600  rounded-lg hover:bg-blue-700  hover:text-white font-bold text-sm">Confirm</a>
              </div>
          </div> 
       </vue-modal-2> 
        <vue-modal-2 name="ModalPayConfirm" :headerOptions="{title: 'Confirm payment'}"  :noFooter="true" modalSize="lg" @on-close="OpenClosePopPayMethode('close','ModalPayConfirm')">
          <loading :active.sync="loadingPay" :is-full-page="fullPage"></loading>
          <div class="bg-white rounded-lg">
              <div class="w-96 rounded-lg flex">
              <div class="w-1/3 pt-6 flex justify-center items-center">
                  <span class="w-16 h-16 bg-blue-600  text-white p-3 rounded-full"><svg class="fill-current" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.31 7.526c-.099-.807.528-1.526 1.348-1.526.771 0 1.377.676 1.28 1.451l-.757 6.053c-.035.283-.276.496-.561.496s-.526-.213-.562-.496l-.748-5.978zm1.31 10.724c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z"/></svg></span>
              </div>
              <div class="w-full pr-4">
                   <div class="text-base mt-1 font-semibold text-gray-600">
                      Payment Information
                  </div>
                
                  <div class="w-full">
                      <div class="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8">
                          <div class="grid grid-cols-1 tab-content">
                              <div id="latest-tasks-new" class="tab-pane active">
                                  <div class="flex items-center mt-5">
                                      <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                          <span  class="font-medium">Seller :</span>
                                          <div v-if="formData.seller" class="text-gray-600">{{ formData.seller.fullName}}</div>
                                      </div>
                                  </div>
                                  <div class="flex items-center mt-5">
                                      <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                          <span  class="font-medium">Payement method :</span>
                                          <div class="text-gray-600">{{ formData.method}}</div>
                                      </div>
                                  </div>
                                  <div class="flex items-center mt-5">
                                      <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                          <span  class="font-medium">Periode date :</span> 
                                          <div class="text-gray-600">{{ formData.intervalDate.fromDate && formData.intervalDate.toDate?'[ '+formData.intervalDate.fromDate+' - '+formData.intervalDate.toDate+' ]':"none"}}</div>
                                      </div>
                                  </div>
                                  <div class="flex items-center mt-5">
                                      <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                          <span  class="font-medium">Nombre des orders :</span>
                                          <div class="text-gray-600">{{ formData.details.length}}</div>
                                      </div>
                                  </div>
                                  
                  
                              </div>
                          </div>
                          <div class="grid grid-cols-1 tab-content">
                                  <div v-if="formData.order_fees.limit && order_fees_vat" class="flex items-center mt-5">
                                      <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                          <span  class="font-medium">Order Fees :</span>
                                          <div class="text-gray-600">{{ (parseFloat(formData.order_fees.limit)*parseFloat(order_fees_vat))}} <sup v-if="idWharhouse">{{idWharhouse.currency}}</sup> {{'('+formData.order_fees.limit+' Orders)'}}</div>
                                      </div>
                                  </div>
                                 <div v-if="formData.expeditions.length>0" class="flex items-center mt-5">
                                      <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                          <span  class="font-medium">Nombre des expeditions :</span>
                                          <div class="text-gray-600">{{ formData.expeditions.length}}</div>
                                      </div>
                                  </div>
                                  <div v-if="formData.refunds.length>0" class="flex items-center mt-5">
                                      <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                          <span  class="font-medium">Nombre des refunds :</span>
                                          <div class="text-gray-600">{{ formData.refunds.length}}</div>
                                      </div>
                                  </div>
                                  <div v-if="formData.sourcings.length>0" class="flex items-center mt-5">
                                      <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                          <span  class="font-medium">Nombre des sourcings :</span>
                                          <div class="text-gray-600">{{ formData.sourcings.length}}</div>
                                      </div>
                                  </div>
                                  <div v-if="formData.avoir_fees.length>0" class="flex items-center mt-5">
                                      <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                          <span  class="font-medium">Avoir amount :</span>
                                          <div class="text-gray-600">(+) {{ formData.avoir_fees.map(item => item.fees).reduce((prev, next) => prev + next) }} <sup v-if="idWharhouse">{{idWharhouse.currency}}</sup></div>
                                      </div>
                                  </div>
  
                                  <div class="flex items-center mt-5">
                                      <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                          <span  class="font-medium">Amount total:</span>
                                          <div class="text-gray-600">{{formData.amount.toFixed(2) }} <sup v-if="idWharhouse">{{idWharhouse.currency}}</sup></div>
                                      </div>
                                  </div>
                           </div>   
                      </div>
                  </div>
              </div>
              </div>
  
              <div class="p-4 flex space-x-4">
              <a href="#" @click="OpenClosePopPayMethode('close','ModalPayConfirm')" class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm">Cancel</a>
              <a href="#" @click="save" class="w-1/2 px-4 py-3 text-center text-blue-100 bg-blue-600  rounded-lg hover:bg-blue-700  hover:text-white font-bold text-sm">Confirm</a>
              </div>
          </div> 
       </vue-modal-2>        
    </div>  
  </template>
  
  <script>
  import tableBody from '@/views/payments/tableOrders.vue' 
  import tableTotalAmount from '@/views/payments/tableTotalAmount.vue'
  import image1 from '@/assets/pay/cash.png' 
  import image2 from '@/assets/pay/paypal.png' 
  import image3 from '@/assets/pay/transfer.png' 
  
  export default {  
     components: {
        tableBody,tableTotalAmount
      },
      props: {
       currentUser: { type: Object},
       idWharhouse: { type: Object}
     },
      data() { 
          return {
              slider:{
                  value: 0,
                  formatter1: '{value} orders',
                      options: {
                          dotSize: 20,
                          width: 'auto',
                          height: 10,
                          contained: false,
                          direction: 'ltr',
                          data: null,
                          dataLabel: 'label',
                          dataValue: 'value',
                          min: 0,
                          max: 5000,
                          interval: 1,
                          disabled: false,
                          clickable: true,
                          duration: 0.5,
                          adsorb: false,
                          lazy: false,
                          tooltip: 'active',
                          tooltipPlacement: 'top',
                          tooltipFormatter: void 0,
                          useKeyboard: false,
                          keydownHook: null,
                          dragOnClick: false,
                          enableCross: true,
                          fixed: false,
                          minRange: void 0,
                          maxRange: void 0,
                          order: true,
                          marks: false,
                          dotOptions: void 0,
                          dotAttrs: void 0,
                          process: true,
                          dotStyle: void 0,
                          railStyle: void 0,
                          processStyle: void 0,
                          tooltipStyle: void 0,
                          stepStyle: void 0,
                          stepActiveStyle: void 0,
                          labelStyle: void 0,
                          labelActiveStyle: void 0,
                      }
              },
              formData: { 
                order_fees:{
                    limit:0,
                    fees:0,
                },
                generateAll:false,  
                seller: null,
                warehouse: null,
                amount: 0,
                fees:{},
                details: [],
                expeditions: [],
                avoir_fees:[],
                refunds: [],
                sourcings: [],
                method: "cash",
                subscription_fees:0,
                intervalDate:{
                  fromDate:null,
                  toDate:null,
                }
              },
              loadingExpeditions:false,
              loadingRefunds:false,
              loadingSourcings:false,
              loadingAvoir_fees:false,
              isFilter:false,
              detailsAllorders:[],
              settings: {
                 shipping: {fees: 0},
                 order: {feesConfirmation: 0,fees:0},
                 subscription_fees:0
              },
              datePaidAt:{
                 fromDate:null,
                 toDate:null,
              },
              tva:[],
              loadingorderbyseller:false,
              ordersByseller:[],
              tvaPayement:"0",
              serviceFeesRate:0,
              transfertFees:0,
              feesVat:0,
              confirmation_vat: 0,
              order_fees_vat: 0,
              shipping_vat: 0,
              shipping_refund_vat: 0,
              shipping_change_vat: 0,
              sellers : [],
              seller: null,
              orders : [],
              totalOrders : [],
              expeditions:[],
              refunds: [],
              avoir_fees:[],
              sourcings: [],
              ordersFees:[{name:'Pending unreached',count:0},{name:'Confirmed',count:0},{name:'Unreached',count:0},{name:"En attente de dépot",count:0},{name:'Cancelled',count:0}],
              loadingordersFees:false,
              shippings:[],
              selectedRows: [],
              fullPage: false,
              loading:false,
              loadingPay:false,
              sellerSelect:null,
              loadingShowPay:false,
              limit: 500,
              shippingType:'normal',
              typeModal:'byorders',
              totalfeesorder:0,
              searchText: "",
              loadingReset:false,
              loadingFind:false,
              loadingRefresh:false,
              totalAmount:0,
              totalOrderscount:0,
              paginate: { 
                  total: 0,
                  currentpage: 1, 
                  lastpage: 1,
                  per_page: 0,
              },
              headings: [
                  { 
                      'value': 'Order & Shipping'
                  },
                  {
                      'value': 'Confirmation fees'
                  },
                  {
                      'value': 'Shipping fees'
                  },
                  // {
                  //     'value': 'Refund fees'
                  // },
                  // {
                  //     'value': 'Change fees'
                  // },
                   {
                      'value': 'Services fees'
                  },
              ],
              options:[
                  { "name": "transfer", "image": "AF" },
                  { "name": "paypal", "image": "AX" },
                  { "name": "cash", "image": "AL" },
               ]
          };
      }, 
      computed: {
          warhouseSelected(){
              return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['warehouses'])});
          },
      }, 
      watch: { 
          'warhouseSelected': async function(oldVal, newVal) {
              // this.detailsAllorders=[];this.formData.details=[];this.ordersByseller=[];this.formData.generateAll=false;
              // this.formData.order_fees={limit:0,fees:0};this.formData.avoir_fees=[];
              // this.formData.expeditions=[];this.formData.refunds=[];this.formData.sourcings=[];
              // await this.getwharhouseId();
              // await this.getSellers();
              // await this.getSettings();
              // this.orders=[];
              // this.isFilter=false;
              // this.formData.seller=null;
              // this.ordersByseller=[]
              // this.paginate.currentpage=1;
              // this.datePaidAt.fromDate=null ;
              // this.datePaidAt.toDate=null ;
              // await this.getAllOrdersBySeller(); 
          },
          'idWharhouse': async function(oldVal, newVal) {
              this.idWharhouse=oldVal;  
              this.detailsAllorders=[];this.formData.details=[];this.ordersByseller=[];this.formData.generateAll=false;
              this.formData.order_fees={limit:0,fees:0};this.formData.avoir_fees=[];
              this.formData.expeditions=[];this.formData.refunds=[];this.formData.sourcings=[];
              await this.getSellers();
              await this.getSettings();
              this.orders=[];
              this.isFilter=false;
              this.formData.seller=null;
              this.ordersByseller=[]
              this.paginate.currentpage=1;
              this.datePaidAt.fromDate=null ;
              this.datePaidAt.toDate=null ;
              await this.getAllOrdersBySeller(); 
              
          },
          'formData.order_fees.limit': async function(oldVal, newVal) {
               this.TotalAmountOrders();
          },
     },
      async mounted() {
          await this.getSellers();
          await this.getSettings();
          await this.getAllOrdersBySeller();
      },
      methods: {
          RouterBack: function() {
              this.$router.back();
          },
          deselectAll(){
              let columns = document.querySelectorAll('.form-checkbox');
              columns.forEach(column => {column.checked = false});
          },
          downloadCsv: function () {
                   //this.dataExcel=[];
                  if(!this.isFilter && !this.formData.seller && this.ordersByseller.length>0) {
                          var nameTable="payments";
                          var htmls = "";
                          var uri = 'data:application/vnd.ms-excel;base64,';
                          var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'; 
                          var base64 = function(s) {
                              return window.btoa(unescape(encodeURIComponent(s)))
                          };
  
                          var format = function(s, c) {
                              return s.replace(/{(\w+)}/g, function(m, p) {
                                  return c[p];
                              })
                          };
                          const table =document.getElementById("p-table");
                          htmls =table.outerHTML
                          var ctx = {
                              worksheet : nameTable,
                              table : htmls
                          }
  
                          var link = document.createElement("a");
                          link.download = nameTable+".xls";
                          link.href = uri + base64(format(template, ctx));
                          link.click();
                  };
          },
          QuantityTotalOrPrices(type,data){
                  var value=0;
                  for (let i in data) {
                      if(type=='qte') value+=data[i].quantity;
                      if(type=='price') value+=data[i].price;
                      else value+=data[i].priceDH;
                      
                  }
                  return value;
          },
          ProductNamesGroup(data){
              let product="";
              for (let i in data) {
                  product+=data[i].productName
                  if(data.length-1 != i) product+=" ,"; 
              }
              return product;
          },
          async refreshDataSeller(){
             if(this.formData.seller){
                // this.datePaidAt.fromDate=null ;
               //  this.datePaidAt.toDate=null ;
                 this.loadingRefresh=true;
                 await this.getOrdersBySeller(this.formData.seller);
                 this.loadingRefresh=false;
             }
          },
          async reset(){
              this.orders=[];
              this.isFilter=false;
              this.formData.seller=null;
              this.ordersByseller=[]
              this.paginate.currentpage=1;
              this.datePaidAt.fromDate=null ;
              this.datePaidAt.toDate=null ;
              this.loadingReset=true;
              await this.getAllOrdersBySeller();
             this.loadingReset=false;
          },
           async FindOrderByBetweenDate(){
               this.loadingFind=true;
               if(this.formData.seller){
                  const filters = {};
                  await this.getOrdersBySeller(this.formData.seller);
               }else{
                 this.ordersByseller=[];
                 await this.getAllOrdersBySeller();
               }
                this.loadingFind=false;
          },
          async getwharhouseId(){
             await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.warhouseSelected,}).then((res) => {this.idWharhouse=res;})
          }, 
          async getSettings(seller=null) {
              const data = await this.$server.get("settings");
              this.settings = data.content;
              this.tva=data.content.tva;
              const currentSettingW= this.$f.getElementInArray(this.settings.details,this.idWharhouse._id);
              if(currentSettingW) this.settings=currentSettingW;
              else this.settings= {shipping: {fees: 0,refund: 0,change: 0,feesRanges: []},order: {feesConfirmation: 0,fees:0},services_fees:0, subscription_fees:0}
  
              this.serviceFeesRate=this.settings.services_fees;
              if(seller) this.seller=seller;
              if(this.seller){
                console.log('seller-------',this.seller)
                console.log('warehouse-------',this.idWharhouse)
                  const currentSettingSeller= this.$f.getElementInArray(this.seller.fees,this.idWharhouse._id);
                  //fees confirmation
                  if((currentSettingSeller && currentSettingSeller.confirmation == -1) || !currentSettingSeller || (currentSettingSeller && !currentSettingSeller.confirmation)) this.confirmation_vat= this.settings.order.feesConfirmation;
                  else this.confirmation_vat= currentSettingSeller.confirmation;
  
                  //Order fees
                  
                  if((currentSettingSeller && currentSettingSeller.order_fees == -1) || !currentSettingSeller || (currentSettingSeller && !currentSettingSeller.order_fees)) this.order_fees_vat= this.settings.order.fees;
                  else this.order_fees_vat= currentSettingSeller.order_fees;
                  
  
                  //fees shipping
                  if((currentSettingSeller && currentSettingSeller.shipping == -1) || !currentSettingSeller || (currentSettingSeller && !currentSettingSeller.shipping)) this.shipping_vat= this.settings.shipping.fees;
                  else this.shipping_vat= currentSettingSeller.shipping;
                  //change shipping
              //     if(this.seller.fees.change == -1) this.shipping_change_vat= this.settings.shipping.change;
              //     else this.shipping_change_vat= this.seller.fees.change;
              //     //refund shipping
              //     if(this.seller.fees.refund == -1) this.shipping_refund_vat= this.settings.shipping.refund;
              //     else this.shipping_refund_vat= this.seller.fees.refund;
              }
          },
          getImagePay(name){
              if(name=="cash")  return image1;
              else if(name=="paypal") return image2;
              else return image3;
          },
          setSelected(method) {
              if (method) {
                  this.formData.method = method.name;
              } else {
                  this.formData.method = "cash";
              }
          }, 
          setTva(tva){
             let tvafees=0;
             if(!this.transfertFees) this.transfertFees=0;
             if(parseFloat(this.transfertFees)!=0) tvafees +=parseFloat(this.transfertFees);
  
             if (tva) {
                if(parseInt(tva)>0){ 
                   this.TotalAmountOrders();
                   tvafees += (this.formData.amount*tva)/100;
                   this.TotalAmountOrders(tvafees);
                   console.log('amount TVA______________',this.formData.amount)
                 }
              }else{
                 this.TotalAmountOrders(tvafees);
                 this.tvaPayement="0";
              }
              this.feesVat=parseFloat(tvafees);
          },
          setTranferfees(event){
              if(!this.transfertFees) this.transfertFees=0;
              let fees=parseFloat(this.transfertFees);
              this.TotalAmountOrders();
              if(parseInt(this.tvaPayement)!=0) fees += (this.formData.amount*parseFloat(this.tvaPayement))/100;
              this.TotalAmountOrders(fees);
          },
          async getAllOrdersBySeller() {
               this.loadingorderbyseller=true;
               this.ordersByseller=[];
               const data={settings:this.settings,warehouse:this.idWharhouse._id,user:this.currentUser};
               if(this.datePaidAt.toDate) data.datePaidAt=this.datePaidAt;
               const res = await this.$server.getOrdersByseller("orders",data);
               this.loadingorderbyseller=false;
               if(res) this.ordersByseller=res
               else this.ordersByseller=[];
               this.totalAmount=0;
               this.totalOrderscount=0;
               this.ordersByseller.forEach(e => { this.totalAmount += e.amount;this.totalOrderscount += e.count;});
          },
         async getOrdersBySeller(seller) {
              this.orders=[];
              this.detailsAllorders=[];this.formData.details=[];this.ordersByseller=[];this.formData.generateAll=false;
              this.formData.expeditions=[];this.formData.refunds=[];this.formData.sourcings=[];this.formData.avoir_fees=[];
              this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}
              if(seller){
               
                this.formData.seller=seller;
                const filters = {warehouse:this.idWharhouse._id};
                this.sellerSelect=seller._id.toString();
                this.loadingShowPay=true;
                this.loading = true;
                if(this.datePaidAt.toDate) this.formData.intervalDate=this.datePaidAt;    
                else this.formData.intervalDate = {fromDate:null,toDate:null}
               // return false
                await this.getSettings(seller);
                await this.getSeller(seller._id);
                await this.getTotalOrders();
                await this.getOrders(filters);
                this.loading = false;
                await this.getOrdersBysellerTraits(filters);
                await this.getExpedition(filters);
                delete filters.paid;
                await this.getRefunds(filters);
                await this.getSourcings(filters);
                await this.getAvoirs(filters);
                this.loadingShowPay=false;
              }else this.sellerSelect=null;        
          },
          async refresh() {
              const filters = {warehouse:this.idWharhouse._id};
              await this.getOrders(filters);
              await this.getOrdersBysellerTraits(filters);
              await this.getExpedition(filters);
              delete filters.paid;
              await this.getRefunds(filters);
              await this.getSourcings(filters);
              await this.getAvoirs(filters);
              //await this.getShippings(filters);
              await this.getSettings();
              await this.getTotalOrders();
          },
          TotalProductOrder(data){
              let totalProduct=0;
              data.forEach(item => {totalProduct += item.quantity;});
              return totalProduct;
          },
            getShippingFeesByOrderPrice(orderPrice) {
                const shippingConfig = this.settings.shipping;
                
                // If no ranges defined or seller has custom fixed fee
                if (!shippingConfig.feesRanges || shippingConfig.feesRanges.length === 0) {
                    return this.shipping_vat; // Use default/seller specific fee
                }

                // Check seller specific settings first
                if (this.seller) {
                    const currentSettingSeller = this.$f.getElementInArray(this.seller.fees, this.idWharhouse._id);
                    // If seller has custom shipping fee (not -1), use it instead of ranges
                    if (currentSettingSeller && currentSettingSeller.shipping && currentSettingSeller.shipping != -1) {
                        return currentSettingSeller.shipping;
                    }
                }

                // Sort ranges by minPrice
                const sortedRanges = [...shippingConfig.feesRanges].sort((a, b) => a.minPrice - b.minPrice);

                // Find matching range
                for (const range of sortedRanges) {
                    const minPrice = range.minPrice || 0;
                    const maxPrice = range.maxPrice || Infinity;

                    if (orderPrice >= minPrice && (maxPrice === 0 || orderPrice <= maxPrice)) {
                        return range.fees;
                    }
                }

                // Fallback to default
                return this.shipping_vat;
         },
          async totalorderFees(order,conf_fees,shipp_fees,refund_fees,change_fees){
              console.log('order details----',order)
              let confirm_fees = conf_fees ;
              //let shipping_fees=  shipp_fees;
              let shipping_fees = this.getShippingFeesByOrderPrice(order.orderObjet.totalPrice);

              let refundd_fees=0;let services_fees=0
              if(order.status =='refunded' ){ refundd_fees=refund_fees; }
              else services_fees=(order.orderObjet.totalPrice*this.serviceFeesRate)/100;
              // if(this.shippingType == "change"){this.shipping_change_vat= this.shipping_change_vat * this.shippingTypeChangCount; this.order.shipping_change_vat = this.shipping_change_vat * this.shippingTypeChangCount;}
              // else this.shipping_change_vat=0;
              let changes_fees=0;
              let totalfees=0;
              totalfees+= confirm_fees+ shipping_fees+refundd_fees+changes_fees+services_fees;
              this.detailsAllorders.push({order:order.order._id||order.order,shipping:order._id,warehouse:order.warehouse._id||order.warehouse,seller:order.seller._id||order.seller,totalPrice:order.orderObjet.totalPrice,qte:this.TotalProductOrder(order.orderObjet.details),amount:order.orderObjet.totalPrice-totalfees,confirmation_vat:confirm_fees,shipping_vat:shipping_fees,shipping_refund_vat:refundd_fees,shipping_change_vat:changes_fees,services_fees:services_fees}); 
          },
          async search() {
              this.paginate= {total: 0,currentpage: 1,lastpage: 1,per_page: 0,};
              const search = {
                  name:this.searchText.trim(),
                  seller:this.formData.seller._id,
                  isProcessed:false,
                  status:  'paid'
              }
              if(this.searchText.trim() != ''){
                   console.log('researchs search--------------------',search)
                  const  res = await this.$server.find("shippings", search);
                  this.isFilter=true;
                  console.log('res search--------------------',res)
                  if (res.content.results) {
                      this.orders = res.content.results;
                      this.confirmation_vat=this.shipping_vat=-5;
                      await this.getSettings(this.formData.seller); 
                      this.totalOrders = res.content.results;
                      for (let i in this.totalOrders) {
                          //console.log('this.totalOrders[i]--------1',this.totalOrders[i])
                          if(this.totalOrders[i].status =='refunded')  this.totalOrders[i].orderObjet.totalPrice = 0;
                          await this.totalorderFees(this.totalOrders[i], this.confirmation_vat,this.shipping_vat, this.shipping_refund_vat,this.shipping_change_vat)
                      }
                      this.paginate.total = res.content.total;
                      this.paginate.lastpage = res.content.last_page;
                      this.paginate.per_page = res.content.per_page;
                      this.paginate.currentpage = res.content.current_page;
                  } else {
                      this.orders = [];this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}
                      this.totalOrders = [];
                  }
                   this.detailsAllorders=[];this.formData.details=[];this.formData.generateAll=false;
                    this.formData.expeditions=[];this.formData.refunds=[];this.formData.sourcings=[];this.formData.avoir_fees=[];
              // if (res.content.results) {
              //     this.totalOrders = res.content.results;
              //     for (let i in this.totalOrders) {
              //         if(this.totalOrders[i].status =='refunded')  this.totalOrders[i].order.totalPrice = 0;
              //         await this.totalorderFees(this.totalOrders[i], this.confirmation_vat,this.shipping_vat, this.shipping_refund_vat,this.shipping_change_vat)
              //     }
              //   //console.log('order amount____________________',this.totalOrdersAmountFees()) ;  
              // } else this.totalOrders = [];
              }    
         },
          async getStatusByName(name) {
              const result = await this.$server.get("status",{ name: name });
              return result.content._id;
          },
          async getOrders(filter) {
              if(this.datePaidAt.toDate) filter.datePaidAt=this.datePaidAt;
                filter.seller=this.formData.seller._id;
                filter.limit= this.limit;
                filter.status=  'paid';
                filter.isProcessed=false;
                filter.notPopulate= true;
              const res = await this.$server.search("shippings",filter);
              if (res.content.results) {
                  console.log('res.count------------',res.content.results)
                  this.orders = res.content.results;
                  this.paginate.total = res.content.total;
                  this.paginate.lastpage = res.content.last_page;
                  this.paginate.per_page = res.content.per_page;
                  this.paginate.currentpage = res.content.current_page;
                  // for (let i in this.orders) {
                  //     if(this.orders[i].status.name =='Refunded')  this.orders[i].totalPrice = 0;
                  // }
              } else this.orders = [];
          },
          async getTotalOrders(seller=null) {
              let filter={};
              if(this.datePaidAt.toDate) filter.datePaidAt=this.datePaidAt;
              filter.seller=seller?seller._id:this.formData.seller._id;
              filter.limit= 10000;
              filter.status=  'paid';
              filter.warehouse=  this.idWharhouse._id;
              filter.isProcessed=false;
              filter.notPopulate= true;
              const res = await this.$server.search("shippings",filter);
              this.detailsAllorders=[];this.formData.details=[];this.formData.generateAll=false;
              this.formData.expeditions=[];this.formData.refunds=[];this.formData.sourcings=[];this.formData.avoir_fees=[];
              if (res.content.results) {
                  this.totalOrders = res.content.results;
                  for (let i in this.totalOrders) {
                     //  console.log('this.totalOrders[i]--------2',this.totalOrders[i])
                      if(this.totalOrders[i].status =='refunded')  this.totalOrders[i].orderObjet.totalPrice = 0;
                      await this.totalorderFees(this.totalOrders[i], this.confirmation_vat,this.shipping_vat, this.shipping_refund_vat,this.shipping_change_vat)
                  }
                //console.log('order amount____________________',this.totalOrdersAmountFees()) ;  
              } else this.totalOrders = [];
          },
          totalOrdersAmountFees(){
             let amount=0; let fees=0;
              for (let p = 0; p < this.detailsAllorders.length; p++) {
                  amount+=this.detailsAllorders[p].amount;
                  fees+=this.detailsAllorders[p].confirmation_vat+this.detailsAllorders[p].shipping_change_vat+this.detailsAllorders[p].shipping_refund_vat+this.detailsAllorders[p].shipping_vat+this.detailsAllorders[p].services_fees;
              }
             return {amount:amount,fees:fees,count:this.detailsAllorders.length};
          },
          totalfeesorderF(item){
            this.totalfeesorder= item.confirmation_vat+item.shipping_vat+item.shipping_refund_vat+item.shipping_change_vat;
          },
          async getShippingsType(id){
              const filters = {};
              filters.order=id;
              filters.status='received';
              const res = await this.$server.search("shippings",filters);
              if(res.content.results) {
                 this.shippingType= res.content.results[0].type; 
              };
              return this.shippingType;
          },
          async getOrdersBysellerTraits(filterOrders){
                  filterOrders.seller=this.formData.seller._id;
                  if(this.datePaidAt.toDate) filterOrders.datePaidAt=this.datePaidAt;
                  this.loadingordersFees=true;
                  this.loading=true;
                  const res = await this.$server.getOrdersBysellerTraits("orders",filterOrders);
                  this.loadingordersFees=false;
                  this.loading=false;
                  console.log('res--------',res)
                  if(res && res.length>0) {
                      this.ordersFees = res;  
                      this.slider.options.max=this.ordersFees.reduce((a,curr) => a + curr.count, 0);
                      this.formData.order_fees.limit=this.ordersFees.reduce((a,curr) => a + curr.count, 0);
                  }else {this.ordersFees = [{name:'Pending unreached',count:0},{name:'Confirmed',count:0},{name:'Unreached',count:0},{name:'En attente de dépot',count:0},{name:'Cancelled',count:0}];this.slider.options.max=0;}
          },
          async getExpedition(filterExp){
                delete filterExp.datePaidAt; delete filterExp.status;
                filterExp.seller=this.formData.seller._id;
                filterExp.status= 'received';
                filterExp.limit= 100;
                filterExp.isProcessed=false;
                filterExp.notPopulate=true;
                console.log('filter expeditions----',filterExp)
                this.loadingExpeditions=true;
               const res = await this.$server.search("expeditions",filterExp);
               this.loadingExpeditions=false;
              if(res && res.content.results) {
                    this.expeditions = res.content.results;  
              }else this.expeditions = [];
          },
           async getRefunds(filterExp){
               delete filterExp.datePaidAt;  delete filterExp.status;delete filterExp.notPopulate;
                filterExp.seller=this.formData.seller._id;
                filterExp.status= 'effectue';
                filterExp.limit= 100;
                filterExp.isProcessed=false;
                this.loadingRefunds=true;
                const res = await this.$server.search("refunds",filterExp);
                this.loadingRefunds=false;
              if(res && res.content.results) {
                    this.refunds = res.content.results;  
              }else this.refunds = [];
          },
          async getSourcings(filterExp){
               delete filterExp.datePaidAt;  delete filterExp.status;delete filterExp.notPopulate;
                filterExp.seller=this.formData.seller._id;
                filterExp.status= 'effectue';
                filterExp.limit= 100;
                filterExp.isProcessed=false;
                this.loadingSourcings=true;
             const res = await this.$server.search("sourcings",filterExp);
               this.loadingSourcings=false;
              if(res && res.content.results) {
                  this.sourcings = res.content.results;  
              }else this.sourcings = [];
          },
          async getAvoirs(filterAv){
                delete filterAv.datePaidAt; delete filterAv.status;
                delete filterAv.isProcessed;
                filterAv.seller=this.formData.seller._id;
                filterAv.limit= 100;
                filterAv.status='not used';
                filterAv.notPopulate=true;
                console.log('filter avoirs----',filterAv)
                this.loadingAvoir_fees=true;
                const res = await this.$server.search("avoirs",filterAv);
                this.loadingAvoir_fees=false;
                console.log('res avoirs----',res.content)
                if(res && res.content.results) {
                  this.avoir_fees = res.content.results;  
                }else this.avoir_fees = [];
          },
          async getShippings(filter){
             const res = await this.$server.search("shippings",filter);
              if(res.content.results) {
                    this.shippings = res.content.results;  
              }else this.shippings = [];
          },
          getCost() {
              if(this.formData.details.length>0){
                  var total = 0,qte=0,fees=0,expedition=0,refund=0,sourcing=0,avoir=0;
                  var totalShippingFees = 0;
                  var totalConfirmationFees = 0;
                  var totalServicesFees = 0;

                this.formData.details.forEach(e => {
                    total += e.totalPrice;
                    qte += e.qte;
                    
                    // Sum up individual fees from each order (already calculated with dynamic shipping)
                    totalConfirmationFees += e.confirmation_vat || 0;
                    totalShippingFees += e.shipping_vat || 0;
                    totalServicesFees += e.services_fees || 0;
                });
                 // qte=1;
                  qte=this.formData.details.length;

                  //fees=(this.confirmation_vat+this.shipping_vat)*qte;
                   // Total fees = confirmation + shipping + services (all dynamic per order)
                   fees = totalConfirmationFees + totalShippingFees + totalServicesFees;

                  //var subTotal=total-fees-((total*this.serviceFeesRate)/100);
                  var subTotal = total - fees;

                  //expeditions
                  this.formData.expeditions.forEach(e => {expedition += e.fees;});
                  subTotal -= expedition;
                   //sourcings
                  this.formData.sourcings.forEach(e => {sourcing += e.fees;});
                  subTotal -= sourcing;
                  //refunds
                  this.formData.refunds.forEach(e => {refund += e.fees;});
                  subTotal -= refund;
  
                  //subscription fees
                  subTotal -= this.formData.subscription_fees;
  
                   //avoir fees
                  this.formData.avoir_fees.forEach(e => {avoir += e.fees;});
                  subTotal += avoir;
  
                  //Order fees
                   subTotal -= (parseFloat(this.formData.order_fees.limit)*parseFloat(this.order_fees_vat));
  
                  return {
                    total:total,
                    //serviceFees:(total*this.serviceFeesRate)/100,
                    serviceFees: totalServicesFees,
                    subTotal:subTotal,
                    //fees:fees+(total*this.serviceFeesRate)/100,
                    fees: fees,
                    shippingFees: totalShippingFees,        // NEW: Total shipping fees
                    confirmationFees: totalConfirmationFees, // NEW: Total confirmation fees
                    expedition:expedition,
                    avoir:avoir,
                    refund:refund,
                    sourcing:sourcing,
                    subscription:this.formData.subscription_fees,
                    order_fees:this.formData.order_fees.limit*this.order_fees_vat
                };
              }
          },
          selectAllCheckbox($event) {
              let columns = document.querySelectorAll('.rowCheckbox');
  
              this.formData.details = [];
  
              if ($event.target.checked == true) {
                  columns.forEach(column => {
                      column.checked = true;
                       
                       let order = this.orders.filter(item => item.order.toString() === column.id.toString());
  
                       if(column.id.toString() === order[0].order.toString()) {
                         // Calculate dynamic shipping fee based on order price
                         const shippingFee = this.getShippingFeesByOrderPrice(order[0].orderObjet.totalPrice);

                          const data = {
                              order: column.id,
                              totalPrice:order[0].orderObjet.totalPrice,
                              seller:order[0].seller._id||order[0].seller,
                              warehouse:order[0].warehouse._id||order[0].warehouse,
                              qte:this.TotalProductOrder(order[0].orderObjet.details),
                              shipping: order[0]._id,
                              confirmation_vat: parseFloat(order[0].orderObjet.confirmation_vat),
                              //shipping_vat: parseFloat(order[0].orderObjet.shipping_vat),
                              shipping_vat: parseFloat(shippingFee),
                              shipping_refund_vat: parseFloat(order[0].orderObjet.shipping_refund_vat),
                              shipping_change_vat: parseFloat(order[0].orderObjet.shipping_change_vat),
                              services_fees: parseFloat(order[0].orderObjet.services_fees),
                              amount: this.TotalAmont(order[0].orderObjet.totalPrice,
                                order[0].orderObjet.confirmation_vat,
                                //order[0].orderObjet.shipping_vat,
                                shippingFee,
                                order[0].orderObjet.shipping_refund_vat,
                                order[0].orderObjet.shipping_change_vat,order[0].orderObjet.services_fees)
                          };
                          this.formData.details.push(data);
                       }  
                     
                  });
              } else {
                  columns.forEach(column => {column.checked = false});
                  // let columnsExp = document.querySelectorAll('.checkbox-exp,.checkbox-ref,.checkbox-sour');
                  // columnsExp.forEach(column => {column.checked = false});
                  // this.formData.details = [];
                  // this.formData.expeditions =this.formData.refunds=this.formData.sourcings= [];
              }
              this.TotalAmountOrders();
          },
          TotalAmont:function(total,conf_fees,shipp_fees,refound_fees,chang_fees,serviceF){ 
             let totalAmount= parseFloat(total)-(parseFloat(conf_fees)+parseFloat(shipp_fees)+parseFloat(refound_fees)+parseFloat(chang_fees)+parseFloat(serviceF));
  
             return totalAmount;
          },
          TotalAmountOrders(tva_tarnsFees=null){
               this.formData.amount=0;
              for (let i in this.formData.details) {
                  this.formData.amount += this.formData.details[i].amount;
              }
              for (let k in this.formData.expeditions) {
                  this.formData.amount -= this.formData.expeditions[k].fees;
              }
              for (let j in this.formData.refunds) {
                  this.formData.amount -= this.formData.refunds[j].fees;
              }
              for (const e of this.formData.sourcings) {
                  this.formData.amount -= e.fees;
              }
              for (const b of this.formData.avoir_fees) {
                  this.formData.amount +=b.fees;
              }
              this.formData.amount -= this.formData.subscription_fees;
  
              this.formData.amount -= this.formData.order_fees.limit*this.order_fees_vat;
  
              if(parseFloat(tva_tarnsFees)>0)  this.formData.amount -=tva_tarnsFees;
          },
          TotalFees(){
              var confirmation_vat=0;
              var shipping_vat=0;
              var shipping_refund_vat=0;
              var shipping_change_vat=0;
             
              for (let i in this.formData.details) {
                  confirmation_vat += this.formData.details[i].confirmation_vat;
                  shipping_vat += this.formData.details[i].shipping_vat;
                  shipping_refund_vat += this.formData.details[i].shipping_refund_vat;
                  shipping_change_vat += this.formData.details[i].shipping_change_vat;     
                     
              }
              return confirmation_vat+shipping_vat+shipping_refund_vat+shipping_change_vat ;
          },
          UpdateRowFees(id,data1,data2,data3,data4,data5,amount) {
              this.formData.details.filter(item => {
                  if(item.order === id){
                      item.confirmation_vat=parseFloat(data1);
                      item.shipping_vat=parseFloat(data2);
                      item.shipping_refund_vat=parseFloat(data3);
                      item.shipping_change_vat=parseFloat(data4);
                      item.services_fees=parseFloat(data5);
                      item.amount=amount;
                  }
              });
               this.TotalAmountOrders();
          },
          getRowDetailExp($event,itemExp,id) {
              let itemInRow = this.formData.expeditions.filter(item => item.id.toString() === id.toString());
              let isItemInRow = itemInRow.length > 0;
               if (isItemInRow) { 
                  let pos = this.formData.expeditions.map(function (e) {return e.id.toString();}).indexOf(id.toString());
                  this.formData.expeditions.splice(pos, 1);
              } else {
                  const data = {id: id,fees: parseFloat(itemExp.fees),};     
                  this.formData.expeditions.push(data);
              }
              this.TotalAmountOrders();
            //console.log('expo__payement____',this.formData.expeditions)
          },
          getRowDetailRefund($event,itemRef,id) {
              console.log('refuuuuuuu id-----',id)
              let itemInRow = this.formData.refunds.filter(item => item.id.toString() === id.toString());
              let isItemInRow = itemInRow.length > 0;
               if (isItemInRow) { 
                   console.log('yesssss')
                  let pos = this.formData.refunds.map(function (e) {return e.id.toString();}).indexOf(id.toString());
                  this.formData.refunds.splice(pos, 1);
              } else {    
                   console.log('nonnnnn')
                  this.formData.refunds.push({id:id,fees: parseFloat(itemRef.ObjetDetails.totalPrice),});
              }
              this.TotalAmountOrders();
            //console.log('expo__payement____',this.formData.refunds)
          },
          getRowDetailSubscription($event) {
              if(this.formData.subscription_fees==0) this.formData.subscription_fees=this.settings.subscription_fees;
              else this.formData.subscription_fees=0;
              this.TotalAmountOrders();
          },
          getRowDetailSourcing($event,itemSou,id) {
              let itemInRow = this.formData.sourcings.filter(item => item.id.toString() === id.toString());
              let isItemInRow = itemInRow.length > 0;
               if (isItemInRow) { 
                  let pos = this.formData.sourcings.map(function (e) {return e.id.toString();}).indexOf(id.toString());
                  this.formData.sourcings.splice(pos, 1);
              } else {    
                  let price=0;
                  for (const el of itemSou.details) {
                      price += el.price;
                  }
                  for (const el of itemSou.fees) {
                      price += el.price;
                  }
                  this.formData.sourcings.push({id:id,fees: parseFloat(price),});
              }
              this.TotalAmountOrders();
            //console.log('expo__payement____',this.formData.sourcings)
          },
          getRowDetailAvoir(event,itemSou,id){
              let itemInRow = this.formData.avoir_fees.filter(item => item.id.toString() === id.toString());
              let isItemInRow = itemInRow.length > 0;
               if(isItemInRow) { 
                  let pos = this.formData.avoir_fees.map(function (e) {return e.id.toString();}).indexOf(id.toString());
                  this.formData.avoir_fees.splice(pos, 1);
              }else this.formData.avoir_fees.push({id:id,fees: parseFloat(itemSou.amount),});
              this.TotalAmountOrders();
          },
          getRowDetail($event,item, id) {
             // let rows = this.selectedRows;
             console.log('item_______________',item)
              let itemInRow = this.formData.details.filter(item => item.order.toString() === id.toString());
              let isItemInRow = itemInRow.length > 0;
                  
              if (isItemInRow) { 
                  let pos = this.formData.details.map(function (e) {return e.order.toString();}).indexOf(id.toString());
                  this.formData.details.splice(pos, 1);
              } else {
                // Calculate dynamic shipping fee based on order price
                const shippingFee = this.getShippingFeesByOrderPrice(item.orderObjet.totalPrice);
                console.log('shippingFee------',shippingFee)

                  const data = {
                      order: id,
                      totalPrice:item.orderObjet.totalPrice,
                      seller:item.seller._id||item.seller,
                      warehouse:item.warehouse._id||item.warehouse,
                      qte:this.TotalProductOrder(item.orderObjet.details),
                      shipping:item._id,
                      confirmation_vat: parseFloat(item.orderObjet.confirmation_vat),
                     // shipping_vat: parseFloat(item.orderObjet.shipping_vat),
                      shipping_vat: parseFloat(shippingFee),
                      shipping_refund_vat: parseFloat(item.orderObjet.shipping_refund_vat),
                      shipping_change_vat: parseFloat(item.orderObjet.shipping_change_vat),
                      services_fees: parseFloat(item.orderObjet.services_fees),
                      amount: this.TotalAmont(item.orderObjet.totalPrice,
                        item.orderObjet.confirmation_vat,
                       // item.orderObjet.shipping_vat,
                        shippingFee,
                        item.orderObjet.shipping_refund_vat,
                        item.orderObjet.shipping_change_vat,item.orderObjet.services_fees)
                      };     
                  console.log('data------',data)    
                  this.formData.details.push(data);
                  console.log('details------',this.formData.details)    
              }
               if(this.formData.details.length === 0){
                  let columns = document.querySelectorAll('.checkallbbox');
                  columns.forEach(column => {column.checked = false});
                  // let columnsExp = document.querySelectorAll('.checkbox-exp');
                  // columnsExp.forEach(column => {column.checked = false});
                  //this.formData.expeditions =this.formData.refunds =this.formData.sourcings = [];
              }
              this.TotalAmountOrders();
          },
         
          async getSellers() {
              const filter = {
                  type: "Seller",
                  warehouses:this.idWharhouse._id,
                  limit:10
              };
              const res = await this.$server.search("users", filter);
              if (res.content.results) this.sellers = res.content.results;
              else this.sellers = [];
          },
          getUsersDebance: _.debounce(async function(name) {
              await this.$store.dispatch('wharhouse/searchUser',{type: "Seller",warhouse:this.idWharhouse._id,search:name}).then((res) => {
              this.sellers = res
              })
          }, 500), 
          async getSeller(id) {
              const filter = {
                  _id: id,
              };
              const res = await this.$server.search("users", filter);
              if (res.content.results) this.seller = res.content.results[0];
              else this.seller =null
          },
          async save() {
            let modal_id = "ModalPay";
            this.formData.warehouse=this.idWharhouse;  
            if (this.formData.details.length>0 && this.formData.warehouse) {
                if(Math.sign(this.formData.amount)==0){
                    alert(`Total to pay is 0 !`, "error");
                }else{
                  this.loadingPay = true;
                  //this.formData.vat=parseFloat(this.tvaPayement);  
                  this.formData.vat=parseFloat(this.serviceFeesRate);  
                  this.formData.fees.confirmation_vat=this.confirmation_vat;
                  this.formData.fees.shipping_vat=this.shipping_vat;
                  this.formData.order_fees.fees=this.order_fees_vat;
                  if(this.datePaidAt.toDate) this.formData.intervalDate=this.datePaidAt;    
                  //this.formData.vatFees=parseFloat(this.feesVat);
                  //this.formData.transfert_fees=parseFloat(this.transfertFees);  
                  //  console.log('form data__________________',this.formData)
                  // return false
                  const data = await this.$server.create("payments", this.formData);
                  console.log('data pay_____________________',data)
                  this.loadingPay = false;
                  if (data && data.content && data.content.data) {
                       this.formData.details = [];this.formData.expeditions = [];this.formData.refunds = [];this.formData.sourcings = [];this.formData.order_fees={limit:0,fees:0};this.formData.avoir_fees = [];
                       this.formData.subscription_fees=0;
                       this.shippings=[];
                       this.$vm2.close(modal_id);
                       this.OpenClosePopPayMethode('close','ModalPayConfirm');
                       this.orders=[];
                       this.isFilter=false;
                       this.formData.seller=null;
                       this.ordersByseller=[]
                       await this.getAllOrdersBySeller(); 
                       //await this.refresh();
                      // this.$router.push('/payments')
                       alert("Payement created", "success");  
                  }else{
                        this.$vm2.close(modal_id);
                        this.deselectAll();
                        this.formData.details = [];this.formData.expeditions = [];this.formData.refunds = [];this.formData.sourcings = [];this.formData.order_fees={limit:0,fees:0};this.formData.avoir_fees = [];
                        this.formData.subscription_fees=0;
                        this.shippings=[];
                        if(data.content && data.content.error) alert(data.content.error, "error"); 
                        else  alert("An error occurred, please reload the page and try again !!", "error"); 
                   }
                }
                 
           } else {
               if(!this.formData.warehouse) alert(`No warehouse detected`, "warning");
               else  alert(`No order selected`, "warning");
          }
             
          },
          async getUser() {
              const res = await this.$server.me("users");
              if (res.content) this.currentUser = res.content;
              else this.currentUser = {};
          },
          confirmData(){
               if (this.formData.details.length  > 0 ) {
                   this.$vm2.open("ModalPayConfirm");
               }else alert(`No order selected`, "warning");
          },
          async OpenClosePopPayMethode(action,type=null,seller=null){
              let modal_id = "ModalPay";
              if(type == "ModalPayConfirm") modal_id="ModalPayConfirm";
              if(type === 'allOrders') {
                  this.loadingShowPay=true;
              }
              if(seller) {
                  this.sellerSelect=seller._id.toString();
                  await this.getTotalOrders(seller);
              }else this.sellerSelect=null;
  
              if(action === 'open') {
                  if(type=='selectOrders') this.typeModal="byorders";
                  else this.typeModal="allOrders";
                 if(type === 'allOrders') {
                     this.formData.details=[];this.formData.amount=0;this.formData.order_fees={limit:0,fees:0};
                     this.formData.expeditions=[];this.formData.refunds=[];this.formData.sourcings=[];this.formData.avoir_fees=[];
                     this.formData.details=this.detailsAllorders;
                     this.formData.generateAll=true;
                     if(seller) this.formData.seller=seller;
                     this.formData.amount=this.totalOrdersAmountFees().amount;
                     this.loadingShowPay=false;
                  }
  
                   if (this.formData.details.length  > 0 ) {
                       if(Math.sign(this.formData.amount)==0){
                          alert(`Total to pay is 0 !`, "error");
                      }else this.$vm2.open(modal_id);
  
                   }else alert(`No order selected`, "warning");
              }else {
                  this.$vm2.close(modal_id);
                  if(this.typeModal=="allOrders") {
                     this.formData.details=[];this.formData.amount=0;this.formData.order_fees={limit:0,fees:0};
                     this.formData.expeditions=[];this.formData.refunds=[];this.formData.sourcings=[];this.formData.avoir_fees=[];
                  }
              }
          },
         async paginatation(direction) {
              var page = 0;
              if (direction == "next") {
                  page = ++this.paginate.currentpage;
              } else {
                  page = --this.paginate.currentpage;
              }
              const filters = {
                  page: page,
                  limit: this.limit,
                  warehouse:this.idWharhouse._id
              };
              this.getOrders(filters);
        },
       },
      };
  </script>
  
  <style scoped>
  #vm2__cover_wrapper_ModalPay .vm2_body{
      position: relative;
  }
  
  .text-smm{
      font-size: 12px;
  }
  .payment-table th{
      font-size: 12px;
  }
  .pay .btn-bottom-toolbar{
      margin-left: -15px;
      padding-right: 75px;
  }
  .h-15 {
      height: 4.5rem;
  }
  .empty-row{
     background: repeating-linear-gradient( 53deg , #bfc0c2 4%, #fcfcff 11px 6%, #ffffff 10px 7%, #9d9c9c 15px);
  }
  .text-xss{
   font-size: 11px;
  }
  .toggle__dot {
    top: -.25rem;
    left: -.25rem;
    transition: all 0.3s ease-in-out;
  }
  .total-amount svg{
     width: 35px;
  }
  input:checked ~ .toggle__dot {
    transform: translateX(100%);
    background-color: #63b3ed;
  }
  .flag-img{
      display: inline-block;
      height: 16px;
      vertical-align: text-top;
      line-height: 16px;
      margin-right: 5px;
  }
  .tag_cities{
      width: 100%;
      max-width: 100%;
  }
  .vs__dropdown-toggle {
      border: none;
  }    
  .tag_cities .tag{
     background: rgb(49 130 206 / 16%);
      border-radius: 20px;
      float: left;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      font-size: .8rem;
      font-weight: 500;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      margin-right: 2px;
      margin-bottom: 5px;
      min-height: 28px;
      padding-right: 10px;
      color: rgba(0, 0, 0, 0.7);
      position: relative;
      padding-right: 0;
  }
  .vs-chip--text {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      margin-left: 10px;
  }
  .vs-chip--close {
      width: 20px;
      height: 20px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      border-radius: 50%;
      border: 0;
      margin: 0 4px;
      cursor: pointer;
      background: rgba(0,0,0,.15);
      color: #fff;
      -webkit-transition: all .3s ease;
      transition: all .3s ease;
      cursor: pointer;
  }
   .tag_cities .tag [data-role="remove"]::after {
      content: "x";
      padding: 0px 2px;
      margin-bottom: 3px;
      font-size: 15px;
  }
   .tag_cities .tag [data-role="remove"] {
      margin-left: 8px;
      cursor: pointer;
  }
  .top-100 {
      top: 100%;
  }
  
  .bottom-100 {
      bottom: 100%;
  }
  
  .max-h-select {
      max-height: 300px;
  }
  [type="checkbox"] {
              box-sizing: border-box;
              padding: 0;
  }
  .form-payement{
      min-height: 400px;
  }
  
  dialog[open] {
      animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
  }
  dialog::backdrop {
      background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
      backdrop-filter: blur(3px);
  }
  
  </style>
  